import { useCurrentUser } from '@zapier/payment/src/hooks/useCurrentUser';
import { UseQuery } from '@zapier/payment/src/ts-types';
import { isBrowser } from '@zapier/payment/src/utils/isBrowser';

type UserCurrentAccountResult = {
  accountId: number | undefined;
  error: string | undefined;
  isLoading: boolean;
};

type Props = {
  skip?: boolean;
  useQuery?: UseQuery;
};

export const useCurrentAccountId = (
  props: Props = {}
): UserCurrentAccountResult => {
  const { currentUser, error, isLoading } = useCurrentUser(props);

  const response = {
    accountId: undefined,
    error: error ? 'Error loading current account ID.' : undefined,
    isLoading,
  };

  if (!currentUser || !isBrowser()) {
    return response;
  }

  /**
   * This can actually return a value even if the user isn't logged in.
   * So we need to make sure the user's actually logged in before returning
   * the currentAccountId.
   */
  const currentAccountId = localStorage.getItem('currentAccountId');

  return {
    ...response,
    accountId: currentAccountId ? parseInt(currentAccountId) : undefined,
  };
};
